import { createDropdownOptions } from 'src/helpers/formHelpers'
import {
  useClearances,
  useContractTypes,
  useContracts,
  useHiringManagers,
  usePositionExemptStatuses,
  usePositionPriorities,
  usePositionStatuses,
  useProgramManagers,
  usePositionWorkSettings
} from 'src/queries'

export interface UseLookupsReturn {
  contracts: ReturnType<typeof createDropdownOptions>
  contractTypes: ReturnType<typeof useContractTypes>
  statuses: ReturnType<typeof createDropdownOptions>
  priorities: ReturnType<typeof usePositionPriorities>
  programManagers: ReturnType<typeof useProgramManagers>
  hiringManagers: ReturnType<typeof useHiringManagers>
  clearances: ReturnType<typeof useClearances>
  exemptStatuses: ReturnType<typeof createDropdownOptions>
  workSettings: ReturnType<typeof createDropdownOptions>
}

const useLookups = (): UseLookupsReturn => {
  const contracts = useContracts()
  const statuses = usePositionStatuses()
  const contractTypes = useContractTypes()
  const priorities = usePositionPriorities()
  const programManagers = useProgramManagers()
  const hiringManagers = useHiringManagers()
  const clearances = useClearances()
  const exemptStatuses = usePositionExemptStatuses()
  const workSettings = usePositionWorkSettings()
  return {
    contracts: createDropdownOptions(contracts, { labelKey: 'abbreviation' }),
    statuses: createDropdownOptions(statuses),
    contractTypes,
    priorities,
    programManagers,
    hiringManagers,
    clearances,
    workSettings: createDropdownOptions(workSettings),
    exemptStatuses: createDropdownOptions(exemptStatuses)
  }
}

export default useLookups
